export default [
    {
        path: '/model/scenarios',
        name: 'scenariolist',
        component: () => import('@/views/scenarios/scenarioList.vue'),
        meta: {
            resource: 'Scenarios',
            action: 'read',
        },
    },
    {
        path: '/model/scenario/manage',
        name: 'scenarioCreate',
        component: () => import('@/views/scenarios/createScenario.vue'),
        meta: {
            resource: 'Scenarios',
            action: 'manage',
        },
    },
    {
        path: '/model/scenario/costpools',
        name: 'scenarioCostPools',
        component: () => import('@/views/costpools/costPoolsList.vue'),
        meta: {
            resource: 'Data',
            action: 'create',
        },
    },
    {
        path: '/model/scenarios/calculations',
        name: 'scenariosCalculations',
        component: () => import('@/views/scenarios/scenariosCalculation.vue'),
        meta: {
            resource: 'Data',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/financial-accounts',
        name: 'scenarioFinancialAccounts',
        component: () => import('@/views/financial-accounts/FAView.vue'),
        meta: {
            resource: 'Data',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/first-allocation',
        name: 'scenarioFirstAllocation',
        component: () => import('@/views/allocations/first-allocation/FirstAllocationView.vue'),
        meta: {
            resource: 'Allocations',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/second-allocation',
        name: 'scenarioSecondAllocation',
        component: () => import('@/views/allocations/second-allocation/SecondAllocationView.vue'),
        meta: {
            resource: 'Allocations',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/third-allocation',
        name: 'scenarioThirdAllocation',
        component: () => import('@/views/allocations/third-allocation/ThirdAllocationView.vue'),
        meta: {
            resource: 'Allocations',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/fourth-allocation',
        name: 'scenarioFourthAllocation',
        component: () => import('@/views/allocations/fourth-allocation/FourthAllocationView.vue'),
        meta: {
            resource: 'Allocations',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/fifth-allocation',
        name: 'scenarioFifthAllocation',
        component: () => import('@/views/allocations/fifth-allocation/FifthAllocationView.vue'),
        meta: {
            resource: 'Allocations',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/sixth-allocation',
        name: 'scenarioSixthAllocation',
        component: () => import('@/views/allocations/sixth-allocation/SixthAllocationView.vue'),
        meta: {
            resource: 'Allocations',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/activities',
        name: 'scenarioActivities',
        component: () => import('@/views/allocations/activities/ActivitiesView.vue'),
        meta: {
            resource: 'Allocations',
            action: 'create',
        },
    },
]
